import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { IIntakeIntroStepPageContent, IntakeIntroStep } from '@ui/routes/shared/IntakeIntroStep';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

interface IMHIntakeIntroStepPageProps extends IFlowStepProps {}

const MHIntakeIntroStepPage: FC<IMHIntakeIntroStepPageProps> = ({ path, stepKey }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "mh-intake-intro-step" }) {
				intake_cards {
					title
					description
					image
					alt_text
					time_upper_bound
					time_lower_bound
					time_units
				}
				page_header
				page_info
			}
		}
	`);

	const { handleNavNext } = useContext(FlowContext);

	const refinedContent: IIntakeIntroStepPageContent = keysToCamel(
		pageContent
	) as IIntakeIntroStepPageContent;

	return (
		<IntakeIntroStep
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			handleNavNext={handleNavNext}
		/>
	);
};

export default MHIntakeIntroStepPage;
